import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20soft%20flowing%20waves%20and%20gentle%20organic%20shapes%20in%20warm%20coral%20peach%20and%20cream%20tones%2C%20elegant%20feminine%20aesthetic%2C%20dreamy%20atmosphere%2C%20minimalist%20art%20style%2C%20calm%20and%20peaceful%20vibe%2C%20no%20text%20no%20people%20just%20abstract%20flowing%20textures&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-semibold text-white mb-5 leading-tight">
          {siteConfig.tagline}
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          用科学、温暖的方式，帮助你了解自己的身体，消除误解，建立积极的性健康观念。
          每一篇文章都由专业团队精心编写，为你的自我探索之旅提供可靠的知识支持。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/chaopen-yuanli"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            探索潮喷原理
          </Link>
          <Link
            to="/category/ziwei-jiqiao"
            className="px-7 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm font-medium hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
          >
            学习自慰技巧
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}